import { FC, ReactNode, useEffect } from 'react';
import { useRouter } from 'next/router';
import { sendPageViewToLogingress } from '~/utils/logingress/smartphoneMonshinLogingress';
import { sendBookingPageViewToLogingress } from '~/utils/logingress/bookingLogingress';

type Props = {
  children: ReactNode;
};

export const PageViewWatcher: FC<Props> = ({ children }) => {
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;
    sendPageViewToLogingress();

    // 集患サポートのページは、別途ページビューを取っている
    // /pharmacy-bookings は pathname に booking を含むが医療機関予約ではない
    if (router.pathname.includes('booking') && !router.pathname.startsWith('/pharmacy-bookings')) {
      sendBookingPageViewToLogingress();
    }
  }, [router.pathname, router.isReady]);

  return <>{children}</>;
};
